import {NumberInput} from 'platform/components';

import type {useDateRangeFilter} from '../../utils/useDateRangeFilter';

type RelativeInput = {value: string; label: string};

type RelativeInputsSectionProps = {
  relativeInputs: RelativeInput[];
  filter: Pick<ReturnType<typeof useDateRangeFilter>, 'onInputChange' | 'relativeInput'>;
  isDisabled?: boolean;
  /** Builds the per-input testid; supplied by the host so ids stay identical across filters. */
  getInputTestId: (label: string) => string | undefined;
};

/**
 * Renders one NumberInput per relative-date input ("days ago", "weeks ahead", …),
 * shared by DateRangeFilter and DateTimeRangeFilter. Each input shows the active
 * relative value for its key (0 otherwise) and reports changes via
 * `filter.onInputChange`. The testid prefix differs per host filter, so the caller
 * supplies `getInputTestId` to keep ids byte-identical.
 */
export function RelativeInputsSection(props: RelativeInputsSectionProps) {
  return (
    <>
      {props.relativeInputs.map((relativeInput) => (
        <NumberInput
          key={relativeInput.value}
          label={relativeInput.label}
          isDisabled={props.isDisabled}
          onChange={(value) => props.filter.onInputChange(value ?? 0, relativeInput.value)}
          value={
            relativeInput.value === props.filter.relativeInput?.relativeInputKey
              ? props.filter.relativeInput.relativeInputValue
              : 0
          }
          data-testid={props.getInputTestId(relativeInput.label)}
        />
      ))}
    </>
  );
}
